import { PaginationBody } from '@Entities/pagination'
import { applyMultiSort, paginationPath2v, portalBase2v, songwriterBase2v } from '@App/dicts/pathes'
import { RecordingGroupStatus } from '@Components/MatchComponents/v2/recording-group-status'

export class Songwriter {
    list = portalBase2v('songwriter')
    summary = (id: string) => songwriterBase2v(id)
    writerSearch = (pagination: PaginationBody, id: string) =>
        new URL(songwriterBase2v(id, `writer/search${paginationPath2v(pagination)}`)).toString()
    searchCowriters = (id: string, pagination: PaginationBody) =>
        new URL(songwriterBase2v(id, `cowriters/search${paginationPath2v(pagination)}`)).toString()

    searchCowriterWorks = (id: string, pagination: PaginationBody) => {
        const url = new URL(songwriterBase2v(id, `cowriters/search/catalog${paginationPath2v(pagination)}`))
        applyMultiSort(url, pagination)
        return url.toString()
    }
    writerLinkSearch = (id: string) => songwriterBase2v(id, 'writerLink/search')
    linkWriter = (id: string, writerIpId: number) => songwriterBase2v(id, `writer/${writerIpId}`)
    writerUpdateRequest = (id: string, writerIpId: number) => songwriterBase2v(id, `writer/${writerIpId}/updateRequest`)
    writerMergeRequest = (id: string, writerIpId: number) => songwriterBase2v(id, `writer/${writerIpId}/mergeRequest`)
    writerIpiUpdateRequest = (id: string, writerIpId: number) =>
        songwriterBase2v(id, `writer/${writerIpId}/ipiUpdateRequest`)
    searchSongwriterCatalog = (id: string, pagination: PaginationBody) => {
        const url = new URL(songwriterBase2v(id, `catalog/search${paginationPath2v(pagination)}`))
        if (pagination) {
            applyMultiSort(url, pagination)
        }
        return url.toString()
    }
    searchSongwriterCatalogSuggestions = (id: string, property: string, searchTerm: string) =>
        new URL(
            songwriterBase2v(id, `catalog/search/suggestions?property=${property}&searchTerm=${searchTerm}`)
        ).toString()

    originalPublisherSubmissionSuggestion = (id: string, workPropertyId: string | number) =>
        songwriterBase2v(id, `work/${workPropertyId}/original-publishers/submission`)

    unmatchedSongwriterSearch = (songwriterId: string, queryString: string) =>
        songwriterBase2v(songwriterId, `search/unmatched-recordings?${queryString}`)

    matchSummary = (id: string) => new URL(songwriterBase2v(id, `matching/summary`)).toString()

    createMatchSuggestion = (id: string) => new URL(songwriterBase2v(id, `matching/suggestions`)).toString()

    matchSuggestion = (id: string, matchSuggestionId: number) => {
        const url = new URL(songwriterBase2v(id, `matching/suggestions/${matchSuggestionId}`))
        return url.toString()
    }

    matchSuggestions = (id: string, statuses: string[], sort: string, pagination?: PaginationBody) => {
        const url = new URL(songwriterBase2v(id, `matching/suggestions${paginationPath2v(pagination)}`))
        url.searchParams.append('sort', sort + ',desc')
        statuses.forEach((status: string) => url.searchParams.append('status', status))
        return url.toString()
    }

    matchRecordingGroupDetails = (
        id: string,
        matchSuggestionId: number,
        recordingGroupStatus: RecordingGroupStatus[],
        pagination?: PaginationBody
    ) => {
        const url = new URL(
            songwriterBase2v(
                id,
                `matching/suggestions/${matchSuggestionId}/recording_groups${paginationPath2v(pagination)}`
            )
        )
        recordingGroupStatus.forEach((status: string) => url.searchParams.append('status', status))
        return url.toString()
    }

    deleteSongwriter = (id: string) => portalBase2v(`songwriter/${id}`)
}
